import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import { DEFAULT_TOOLTIP_OPTIONS } from './constant';
var Stock = /** @class */ (function (_super) {
    __extends(Stock, _super);
    function Stock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'stock';
        return _this;
    }
    /**
     * 默认配置
     *  g2/g2plot默 认 配 置 -->  图 表 默 认 配 置  --> 开 发 者 自 定 义 配 置  --> 最 终 绘 图 配 置
     */
    Stock.prototype.getDefaultOptions = function () {
        return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
            // 设置默认图表 tooltips
            tooltip: DEFAULT_TOOLTIP_OPTIONS,
            interactions: [{ type: 'tooltip' }],
        });
    };
    /**
     * 获取 蜡烛图 的适配器
     */
    Stock.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Stock;
}(Plot));
export { Stock };
//# sourceMappingURL=index.js.map